import { render, staticRenderFns } from "./ReOpenReply.vue?vue&type=template&id=e709bd96&scoped=true"
import script from "./ReOpenReply.vue?vue&type=script&lang=js"
export * from "./ReOpenReply.vue?vue&type=script&lang=js"
import style0 from "./ReOpenReply.vue?vue&type=style&index=0&id=e709bd96&lang=css"
import style1 from "./ReOpenReply.vue?vue&type=style&index=1&id=e709bd96&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e709bd96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e709bd96')) {
      api.createRecord('e709bd96', component.options)
    } else {
      api.reload('e709bd96', component.options)
    }
    module.hot.accept("./ReOpenReply.vue?vue&type=template&id=e709bd96&scoped=true", function () {
      api.rerender('e709bd96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/customer-service/components/Modal/ReOpenReply.vue"
export default component.exports